import { FC, ReactNode } from "react";
import ModalRoot from "./ModalRoot";
import { Toaster } from "@src/ui/sonner";

type Props = {
  children: ReactNode;
};

export const Layout: FC<Props> = ({ children }: Props) => {
  return (
    <>
      {children}
      <ModalRoot />
      <Toaster />
    </>
  );
};

export default Layout;
